<div class="row mt-4">
  <div class="col-md-12">
    <mat-card class="property-card">
      <!-- Title & Subtitle on the Left -->
      <div class="mat-card-group m-btngrp">
        <mat-card-title class="card-heading">Initial/Modified Search</mat-card-title>
        <button (click)="editCma()" mat-flat-button color="primary">Custom Comparable Search</button>
      </div>

      <mat-card-content>
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="about-property">
              Our initial results are driven by AVM results and AI similarity scoring. They are a starting point for
              your analysis!
            </div>
            <div class="pro-tips desktop-tip">
              <i
                ><b>Pro tip:</b> Click the Custom Comparable Search button to the right to view results and activate
                custom search at the bottom right of screen for your own defined polygons or radius. As you change
                comps, so does the model. Then nail YOUR value!</i
              >
            </div>
            <div class="pro-tips mobile-tip">
              <i
                ><b>Pro tip:</b> Click the Custom Comparable Search button above to view results and activate custom
                search at the bottom right of screen for your own defined polygons or radius. As you change comps, so
                does the model. Then nail YOUR value!</i
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="tabs-container">
              <!-- Status Tabs -->
              <div class="main-tabs">
                <mat-tab-group #tabGroup class="active" (selectedTabChange)="statusTabChanged($event)">
                  <mat-tab label="All ({{ all }})"></mat-tab>
                  <mat-tab label="Active/Pending ({{ active + pending + activeUc }})"></mat-tab>
                  <mat-tab label="Sold ({{ sold }})"></mat-tab>
                  <!-- <mat-tab label="Pending ({{ pending }})"></mat-tab> -->
                </mat-tab-group>
              </div>

              <!-- View Options using Buttons -->
              <div
                class="view-options"
                matTooltip="Customize your experience by choosing the appropriate layout icons below. Click into the boxes for your optimal sorting!"
                matTooltipPosition="above"
              >
                <button mat-icon-button [class.active]="activeViewTabIndex === 0" (click)="viewTabChanged(0)">
                  <mat-icon>view_column</mat-icon>
                </button>
                <button mat-icon-button [class.active]="activeViewTabIndex === 1" (click)="viewTabChanged(1)">
                  <mat-icon>view_module</mat-icon>
                </button>
                <button mat-icon-button [class.active]="activeViewTabIndex === 2" (click)="viewTabChanged(2)">
                  <mat-icon>list</mat-icon>
                </button>
                <button
                  class="map"
                  mat-icon-button
                  [class.active]="activeViewTabIndex === 3"
                  (click)="viewTabChanged(3)"
                >
                  <mat-icon>map</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="table-responsive prop-list column-view" *ngIf="activeViewTabIndex === 0">
          <table>
            <tbody class="prop-body">
              <tr>
                <td><span class="comp-head">Comparables</span></td>
                <td *ngFor="let property of comparableInfo; trackBy: trackByProperty">
                  <div class="row">
                    <div class="col-12">
                      <img
                        *ngIf="
                          reportType != 'PublicRecordSmartResearch' &&
                          reportType != 'PublicRecordCMA' &&
                          property.ListingId
                        "
                        class="mx-auto report-image"
                        [src]="listingImageBaseUrlAlt + '?ListingId=' + property.ListingId + '&ImageName=1&height=180'"
                      />

                      <img
                        *ngIf="
                          reportType != 'PublicRecordSmartResearch' &&
                          reportType != 'PublicRecordCMA' &&
                          !property.ListingId
                        "
                        class="mx-auto report-image"
                        [src]="listingImageBaseUrlAlt + '?ListingId=null&ImageName=1'"
                      />

                      <div
                        class="map-wrapper"
                        *ngIf="reportType == 'PublicRecordSmartResearch' || reportType == 'PublicRecordCMA'"
                      >
                        <app-birds-eye-view
                          *ngIf="property.showBirdEye"
                          [defaultPlace]="{
                            lat: +property.Latitude,
                            lng: +property.Longitude
                          }"
                          [containerHeight]="'140'"
                        ></app-birds-eye-view>

                        <app-street-view
                          *ngIf="!property.showBirdEye"
                          [defaultPlace]="{
                            lat: +property.Latitude,
                            lng: +property.Longitude
                          }"
                          (streetViewAvailable)="onStreetViewAvailable(property, $event)"
                          [containerHeight]="'140'"
                        ></app-street-view>
                      </div>

                      <p *ngIf="property.SimilarityScore" class="similar-score">
                        {{ getSimilarityScoreCeiled(property.SimilarityScore) }}%
                      </p>
                      <p
                        [ngClass]="{
                          'sold-status': property.StandardStatus === 'Sold',
                          'active-status':
                            property.StandardStatus === 'Active' ||
                            property.StandardStatus === 'Active UC' ||
                            property.StandardStatus === 'Active Under Contract' ||
                            property.StandardStatus === 'Pending',
                          'expired-status': property.StandardStatus === 'Expired',
                          'cancel-status': property.StandardStatus === 'Cancel/Withdrawn'
                        }"
                      >
                        {{ property.StandardStatus }}
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>Address</td>
                <td
                  class="comp-address address prop-itm"
                  (click)="openPropertyDetails(property)"
                  *ngFor="let property of comparableInfo"
                >
                  <div>
                    {{ property.UnparsedAddress || '--' }}
                    <br />
                    <small
                      >{{ property.City || '--' }}, {{ property.StateOrProvince || '--' }}
                      {{ property.PostalCode || '--' }}</small
                    >
                  </div>
                </td>
              </tr>
              <tr class="list-price">
                <td>List Price</td>
                <td *ngFor="let property of comparableInfo">
                  <div class="fw-bold">
                    {{ property.ListPrice != null ? (property.ListPrice | currency: 'USD':'symbol':'1.0-0') : '--' }}
                  </div>
                  <div
                    class="price-sqft"
                    *ngIf="
                      (property.PriceperSquareFeet != null && property.StandardStatus === 'Active') ||
                      property.StandardStatus === 'Active UC' ||
                      property.StandardStatus === 'Active Under Contract' ||
                      property.StandardStatus === 'Pending'
                    "
                  >
                    Price/sq.ft: ${{ property.PriceperSquareFeet | number: '1.0-0' }}
                  </div>
                </td>
              </tr>

              <tr class="sold-price">
                <td>Sold Price</td>
                <td *ngFor="let property of comparableInfo">
                  <div class="fw-bold">
                    {{
                      property.StandardStatus === 'Sold'
                        ? property.ClosePrice != null
                          ? (property.ClosePrice | currency: 'USD':'symbol':'1.0-0')
                          : '--'
                        : '--'
                    }}
                  </div>
                  <div
                    class="price-sqft"
                    *ngIf="property.PriceperSquareFeet != null && property.StandardStatus === 'Sold'"
                  >
                    Price/sq.ft: ${{ property.PriceperSquareFeet | number: '1.0-0' }}
                  </div>
                </td>
              </tr>
              <tr>
                <td>Beds</td>
                <td *ngFor="let property of comparableInfo">{{ property.BedroomsTotal || '--' }}</td>
              </tr>
              <tr>
                <td>Baths</td>
                <td *ngFor="let property of comparableInfo">{{ roundUp(property.BathroomsDecimal) }}</td>
              </tr>
              <tr>
                <td>Parking Spaces</td>
                <td *ngFor="let property of comparableInfo">{{ property.ParkingSpaces || '--' }}</td>
              </tr>
              <tr>
                <td>GLA (sqFt)</td>
                <td *ngFor="let property of comparableInfo">{{ (property.LivingArea | number: '1.0-0') || '--' }}</td>
              </tr>
              <tr>
                <td>Lot Size (sqFt)</td>
                <td *ngFor="let property of comparableInfo">
                  {{ (property.LotSizeSquareFeet | number: '1.0-0') || '-' }}
                </td>
              </tr>
              <tr *ngIf="reportType != 'PublicRecordCMA'">
                <td>Sold Date</td>
                <td *ngFor="let property of comparableInfo">
                  <div>
                    {{
                      property.StandardStatus == 'Sold' && property.CloseDate != null
                        ? (property.CloseDate | date: 'MM/dd/yy')
                        : '--'
                    }}
                  </div>
                </td>
              </tr>
              <tr *ngIf="reportType != 'PublicRecordCMA'">
                <td>DOM</td>
                <td *ngFor="let property of comparableInfo">
                  <div>
                    {{ property.StandardStatus == 'Active' ? (property.DaysOnMarket | number: '1.0-0') : '--' }}
                  </div>
                </td>
              </tr>
              <tr>
                <td>Proximity</td>
                <td *ngFor="let property of comparableInfo">
                  {{ property.Distance != null ? (property.Distance | number) : '--' }}
                </td>
              </tr>
              <tr>
                <td>Year Built</td>
                <td *ngFor="let property of comparableInfo">{{ property.YearBuilt || '--' }}</td>
              </tr>
              <tr>
                <td>School</td>
                <td *ngFor="let property of comparableInfo">
                  <ng-container *ngFor="let school of property.schools; let i = index">
                    <a (click)="openSchoolInfo(school)" class="school-link"> {{ i + 1 }}. {{ school.SchoolName }} </a>
                    <br />
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row mt-3" *ngIf="activeViewTabIndex === 1">
          <div class="col-lg-3 col-md-4 col-sm-6 col-12" *ngFor="let property of pagedComparableInfo; let i = index">
            <mat-card class="report-card mb-4" (click)="openPropertyDetails(property)" style="cursor: pointer">
              <mat-card-content>
                <mat-card-title>
                  <!-- <div class="row pr-0">
                    <div class="col-10 pr-0">
                      <h5 class="prop-address">{{ property.reportName }} <br /></h5>
                    </div>
                  </div> -->
                  <div>
                    <div class="row mb-2">
                      <div class="col-12">
                        <img
                          *ngIf="
                            reportType != 'PublicRecordSmartResearch' &&
                            reportType != 'PublicRecordCMA' &&
                            property.ListingId
                          "
                          class="img-fluid mx-auto card-img"
                          [src]="
                            listingImageBaseUrlAlt + '?ListingId=' + property.ListingId + '&ImageName=1&height=500'
                          "
                        />

                        <img
                          *ngIf="
                            reportType != 'PublicRecordSmartResearch' &&
                            reportType != 'PublicRecordCMA' &&
                            !property.ListingId
                          "
                          class="mx-auto report-image"
                          [src]="listingImageBaseUrlAlt + '?ListingId=null&ImageName=1'"
                        />

                        <div
                          class="map-card-view"
                          *ngIf="reportType == 'PublicRecordSmartResearch' || reportType == 'PublicRecordCMA'"
                        >
                          <app-birds-eye-view
                            *ngIf="property.showBirdEye"
                            [defaultPlace]="{
                              lat: +property.Latitude,
                              lng: +property.Longitude
                            }"
                            [containerHeight]="'170'"
                          >
                          </app-birds-eye-view>

                          <app-street-view
                            *ngIf="!property.showBirdEye"
                            [defaultPlace]="{
                              lat: +property.Latitude,
                              lng: +property.Longitude
                            }"
                            [containerHeight]="'170'"
                            (streetViewAvailable)="onStreetViewAvailable(property, $event)"
                          ></app-street-view>
                        </div>

                        <p *ngIf="property.SimilarityScore" class="similar-score">
                          {{ getSimilarityScoreCeiled(property.SimilarityScore) }}%
                        </p>
                        <p
                          [ngClass]="{
                            'sold-status': property.StandardStatus === 'Sold',
                            'active-status':
                              property.StandardStatus === 'Active' ||
                              property.StandardStatus === 'Active UC' ||
                              property.StandardStatus === 'Active Under Contract' ||
                              property.StandardStatus === 'Pending',
                            'expired-status': property.StandardStatus === 'Expired',
                            'cancel-status': property.StandardStatus === 'Cancel/Withdrawn'
                          }"
                        >
                          {{ property.StandardStatus }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-7 pr-0">
                      <h5 class="prop-address">
                        {{ property.UnparsedAddress }} <br />
                        <span class="sub-address"
                          >{{ property.City }}, {{ property.StateOrProvince }} {{ property.PostalCode }}
                        </span>
                      </h5>
                    </div>
                    <div class="col-5 pl-1">
                      <div class="prop-address report-close">
                        {{
                          property.StandardStatus === 'Sold'
                            ? property.ClosePrice != null
                              ? (property.ClosePrice | currency: 'USD':'symbol':'1.0-0')
                              : ''
                            : property.ListPrice != null
                            ? (property.ListPrice | currency: 'USD':'symbol':'1.0-0')
                            : ''
                        }}
                        <br />
                        <span class="sub-address">{{
                          property.StandardStatus === 'Sold'
                            ? property.ClosePrice != null
                              ? 'Sold Price'
                              : ''
                            : property.ListPrice != null
                            ? 'List Price'
                            : ''
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="row">
                      <div class="col-6 pr-0 prop-items">
                        <p class="prop-value">
                          <span class="prop-label">Bed: </span> <b>{{ (property.BedroomsTotal | number) || '-' }}</b>
                        </p>
                      </div>
                      <div class="col-6 prop-items">
                        <p class="prop-value">
                          <span class="prop-label">Baths: </span>
                          <b>{{ roundUp(property.BathroomsDecimal) }}</b>
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 prop-items pr-0">
                        <p class="prop-value">
                          <span class="prop-label">GLA: </span>
                          <b>{{ (property.LivingArea | number) || '-' }} <small>sq.ft</small> </b>
                        </p>
                      </div>
                      <div class="col-6 pr-0 prop-items">
                        <p class="prop-value">
                          <span class="prop-label">Stories: </span> <b>{{ (property.stories | number) || '-' }}</b>
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 pr-0 prop-items">
                        <p class="prop-value">
                          <span class="prop-label">Year Built: </span> <b>{{ property.yearBuilt || '-' }}</b>
                        </p>
                      </div>
                      <div
                        *ngIf="reportType != 'PublicRecordCMA' && property.StandardStatus === 'Active'"
                        class="col-6 prop-items"
                      >
                        <p class="prop-value">
                          <span class="prop-label">DOM: </span> <b>{{ (property.DaysOnMarket | number) || '-' }}</b>
                        </p>
                      </div>
                      <div
                        *ngIf="reportType != 'PublicRecordCMA' && property.StandardStatus === 'Sold'"
                        class="col-6 prop-items"
                      >
                        <p class="prop-value">
                          <span class="prop-label">Sold Date: </span> <b>{{ property.CloseDate | date: 'MM/dd/yy' }}</b>
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 pr-0 prop-items">
                        <p class="prop-value">
                          <span class="prop-label">Proximity: </span>
                          <b>{{ property.Distance != null ? (property.Distance | number) : '--' }}</b>
                        </p>
                      </div>
                    </div>
                  </div>
                </mat-card-title>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <mat-paginator
          #paginator
          *ngIf="activeViewTabIndex === 1"
          [length]="comparableInfo.length"
          [pageSize]="8"
          [pageSizeOptions]="[8, 12, 24]"
          (page)="onPageChange($event)"
        >
        </mat-paginator>

        <div class="row mt-3" *ngIf="activeViewTabIndex === 2">
          <div class="col-md-12">
            <div class="table-responsive prop-list w-100">
              <table>
                <thead class="prop-head">
                  <tr>
                    <td>#</td>
                    <td>Address</td>
                    <td>Similarity Score</td>
                    <td>List Price</td>
                    <td>Close Price</td>
                    <td>Sold Date</td>
                    <!-- <td>Price/SqFt</td> -->
                    <td>Beds</td>
                    <td>Baths</td>
                    <td>Parking Spaces</td>
                    <td>GLA</td>
                    <td>Lot Size</td>
                    <td *ngIf="reportType != 'PublicRecordCMA'">DOM</td>
                    <td>Proximity</td>
                    <td>Year Built</td>
                    <td class="status">Status</td>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let property of pagedComparableInfo; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td class="address prop-itm" (click)="openPropertyDetails(property)" style="display: flex">
                      <div class="d-inline-flex" style="line-height: 15px">
                        <div class="row mb-2">
                          <div class="col-12">
                            <img
                              *ngIf="property.ListingId"
                              class="img-fluid mx-auto report-image"
                              [src]="
                                listingImageBaseUrlAlt + '?ListingId=' + property.ListingId + '&ImageName=1&height=500'
                              "
                            />
                            <img
                              *ngIf="!property.ListingId"
                              class="img-fluid mx-auto report-image"
                              [src]="listingImageBaseUrlAlt + '?ListingId=null&ImageName=1'"
                            />
                          </div>
                        </div>
                        <div class="prop-ads">
                          {{ property.UnparsedAddress }}
                          <br />
                          <small>{{ property.City }}, {{ property.StateOrProvince }} {{ property.PostalCode }}</small>
                        </div>
                      </div>
                    </td>
                    <td>{{ property.SimilarityScore ? getSimilarityScoreCeiled(property.SimilarityScore) : '--' }}%</td>
                    <td>
                      {{ property.ListPrice != null ? (property.ListPrice | currency: 'USD':'symbol':'1.0-0') : '--' }}
                    </td>

                    <td>
                      {{
                        property.StandardStatus === 'Sold' && property.ClosePrice != null
                          ? (property.ClosePrice | currency: 'USD':'symbol':'1.0-0')
                          : '--'
                      }}
                    </td>
                    <td>
                      {{
                        property.StandardStatus === 'Sold' && property.CloseDate != null
                          ? (property.CloseDate | date: 'MM/dd/yy')
                          : '--'
                      }}
                    </td>

                    <!-- <td>{{ property.PriceperSquareFeet ? (property.PriceperSquareFeet | number: '1.0-0') : '--' }}</td> -->
                    <td>{{ property.BedroomsTotal ? property.BedroomsTotal : '--' }}</td>
                    <td>{{ roundUp(property.BathroomsDecimal) }}</td>
                    <td>{{ property.ParkingSpaces ? property.ParkingSpaces : '--' }}</td>
                    <td>{{ property.LivingArea ? (property.LivingArea | number: '1.0-0') : '--' }}</td>
                    <td>{{ property.LotSizeSquareFeet ? (property.LotSizeSquareFeet | number: '1.0-0') : '--' }}</td>
                    <td *ngIf="reportType != 'PublicRecordCMA'">
                      {{
                        property.StandardStatus === 'Active' && property.DaysOnMarket
                          ? (property.DaysOnMarket | number: '1.0-0')
                          : '--'
                      }}
                    </td>
                    <td>{{ truncateDistance(property.Distance) }}</td>
                    <td>{{ property.YearBuilt ? property.YearBuilt : '--' }}</td>
                    <td class="text-center">
                      <span class="prop-status">{{ property.StandardStatus ? property.StandardStatus : '--' }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <mat-paginator
          #paginator
          *ngIf="activeViewTabIndex === 2"
          [length]="comparableInfo.length"
          [pageSize]="10"
          [pageSizeOptions]="[10, 20, 30]"
          (page)="onPageChange($event)"
        >
        </mat-paginator>
        <div class="row mt-3" *ngIf="activeViewTabIndex === 3">
          <div class="col-md-12">
            <div class="map-img" style="height: 400px">
              <app-geometry-map
                [zoom]="zoom"
                [center]="{ lat: lat, lng: long }"
                [markerList]="markerList"
                [hideControls]="true"
                [hideLegend]="true"
              ></app-geometry-map>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <h4 class="my-3 headWrap">Comparable Property Summary</h4>
            <div class="table-responsive prop-list">
              <table>
                <thead class="prop-head">
                  <tr>
                    <td width="200px"></td>
                    <td width="200px">Active / Pending Listings</td>
                    <td width="200px">Sold Listings</td>
                  </tr>
                </thead>
                <tbody class="prop-body">
                  <tr>
                    <td>Number of Properties</td>
                    <td>
                      {{
                        comparableStats?.listing?.count != null
                          ? (comparableStats?.listing?.count | number: '1.0-0')
                          : '--'
                      }}
                    </td>
                    <td>
                      {{
                        comparableStats?.sold?.count != null ? (comparableStats?.sold?.count | number: '1.0-0') : '--'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Low Price</td>
                    <td>
                      {{
                        comparableStats?.listing?.lowPrice != null
                          ? (comparableStats?.listing?.lowPrice | currency: 'USD':'symbol':'1.0-0')
                          : '--'
                      }}
                    </td>
                    <td>
                      {{
                        comparableStats?.sold?.lowPrice != null
                          ? (comparableStats?.sold?.lowPrice | currency: 'USD':'symbol':'1.0-0')
                          : '--'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>High Price</td>
                    <td>
                      {{
                        comparableStats?.listing?.highPrice != null
                          ? (comparableStats?.listing?.highPrice | currency: 'USD':'symbol':'1.0-0')
                          : '--'
                      }}
                    </td>
                    <td>
                      {{
                        comparableStats?.sold?.highPrice != null
                          ? (comparableStats?.sold?.highPrice | currency: 'USD':'symbol':'1.0-0')
                          : '--'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Average Price</td>
                    <td>
                      {{
                        comparableStats?.listing?.averagePrice != null
                          ? (comparableStats?.listing?.averagePrice | currency: 'USD':'symbol':'1.0-0')
                          : '--'
                      }}
                    </td>
                    <td>
                      {{
                        comparableStats?.sold?.averagePrice != null
                          ? (comparableStats?.sold?.averagePrice | currency: 'USD':'symbol':'1.0-0')
                          : '--'
                      }}
                    </td>
                  </tr>
                  <tr *ngIf="reportType != 'PublicRecordCMA'">
                    <td>Average Days on Market</td>
                    <td>
                      {{
                        comparableStats?.listing?.averageDOM != null
                          ? (comparableStats?.listing?.averageDOM | number: '1.0-0')
                          : '--'
                      }}
                    </td>
                    <td>
                      {{
                        comparableStats?.sold?.averageDOM != null
                          ? (comparableStats?.sold?.averageDOM | number: '1.0-0')
                          : '--'
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <h4 class="my-3 headWrap">Average price per sq.ft</h4>
            <div class="row">
              <div class="col-md-3">
                <div class="scrollable-container">
                  <ng-container *ngFor="let status of ['Sold', 'Pending', 'Active']">
                    <ng-container *ngIf="getCount(status) > 0">
                      <h5>
                        {{ status }}
                        <span class="status-badge" [ngClass]="status.toLowerCase()">{{ getCount(status) }}</span>
                      </h5>

                      <div class="card mb-3" *ngFor="let property of getPropertiesByStatus(status); let i = index">
                        <div class="property-item">
                          <div class="row mb-2">
                            <div class="col-12 d-flex align-items-center">
                              <!-- Image Section -->
                              <img
                                *ngIf="property.ListingId"
                                class="img-fluid mx-auto report-image"
                                [src]="
                                  listingImageBaseUrlAlt +
                                  '?ListingId=' +
                                  property.ListingId +
                                  '&ImageName=1&height=500'
                                "
                              />
                              <img
                                *ngIf="!property.ListingId"
                                class="img-fluid mx-auto report-image"
                                [src]="listingImageBaseUrlAlt + '?ListingId=null&ImageName=1'"
                              />

                              <!-- Property Details Section -->
                              <div class="property-details ms-3">
                                <p class="property-address">{{ property.UnparsedAddress || 'N/A' }}</p>
                                <p class="property-price">
                                  {{
                                    property.PriceperSquareFeet ? '$' + property.PriceperSquareFeet + ' / sq.ft' : 'N/A'
                                  }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
              <div class="col-md-9">
                <div class="average-value">
                  Comparable homes sold for an average of
                  <span>${{ averageLotSizes ? (averageLotSizes.toFixed(0) | number) : '--' }}</span> / sq.ft
                </div>
                <highcharts-chart
                  [Highcharts]="Highcharts"
                  [options]="chartOptions"
                  [update]="updateFlag"
                  (chartInstance)="chartLoaded($event)"
                  style="width: 100%; height: 400px; display: block"
                >
                </highcharts-chart
                >`
              </div>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="reportType != 'PublicRecordCMA'">
          <div class="col-md-12">
            <h4 class="my-3 headWrap">Time to sell</h4>
            <div class="row">
              <div class="col-md-3">
                <div class="scrollable-container">
                  <ng-container *ngFor="let status of ['Sold', 'Pending', 'Active']">
                    <ng-container *ngIf="getCount(status) > 0">
                      <h5>
                        {{ status }}
                        <span class="status-badge" [ngClass]="status.toLowerCase()">{{ getCount(status) }}</span>
                      </h5>
                      <div class="card mb-3" *ngFor="let property of getPropertiesByStatus(status); let i = index">
                        <div class="property-item">
                          <img
                            *ngIf="property.ListingId"
                            class="img-fluid mx-auto report-image"
                            [src]="
                              listingImageBaseUrlAlt + '?ListingId=' + property.ListingId + '&ImageName=1&height=500'
                            "
                          />
                          <img
                            *ngIf="!property.ListingId"
                            class="img-fluid mx-auto report-image"
                            [src]="listingImageBaseUrlAlt + '?ListingId=null&ImageName=1'"
                          />

                          <div class="property-details">
                            <p class="property-address">{{ property.UnparsedAddress || 'N/A' }}</p>
                            <p class="property-price">
                              {{ property.DaysOnMarket }} Days
                              <span *ngIf="status.toLowerCase() == 'sold'">
                                -
                                {{
                                  property.ClosePrice && property.ListPrice
                                    ? ((property.ClosePrice / property.ListPrice) * 100 | number: '1.0-2')
                                    : '-'
                                }}%
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
              <div class="col-md-9">
                <div class="average-value">
                  <span>{{ averageDaysOfMarket ? (averageDaysOfMarket | number: '1.0-0') : '-' }}</span> Days on Market
                  | <span>{{ averageListPrice ? (averageListPrice | number: '1.0-2') : '-' }}</span> of List Price
                </div>
                <small
                  >Sold homes were on the market for an average of
                  {{ averageDaysOfMarket ? (averageDaysOfMarket | number: '1.0-0') : '-' }} days before they accepted an
                  offer. These homes sold for an average of
                  {{ averageListPrice ? (averageListPrice | number: '1.0-2') : '-' }}% of list price.</small
                >

                <highcharts-chart
                  [Highcharts]="Highcharts"
                  style="width: 100%; height: 400px; display: block"
                  [options]="soldChartOptions"
                ></highcharts-chart>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
